import { render } from "./payout.vue?vue&type=template&id=1d8a0aab&scoped=true"
import script from "./payout.vue?vue&type=script&lang=js"
export * from "./payout.vue?vue&type=script&lang=js"

import "./payout.vue?vue&type=style&index=0&id=1d8a0aab&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8a0aab"]])

export default __exports__